"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toUnderscoreCase = exports.convertAllEventsToUnderscoreCase = exports.convertStringToUnderscoreCase = void 0;
var tslib_1 = require("tslib");
function toUnderscoreCase(object, convertToUnderscoreCase) {
    if (convertToUnderscoreCase === void 0) { convertToUnderscoreCase = true; }
    if (object && Object.keys(object).length && convertToUnderscoreCase) {
        return Object.keys(object)
            .map(function (key) {
            var _a;
            return (_a = {}, _a[convertStringToUnderscoreCase(key)] = object[key], _a);
        })
            .reduce(function (prev, next) { return (tslib_1.__assign(tslib_1.__assign({}, prev), next)); });
    }
    return object;
}
exports.toUnderscoreCase = toUnderscoreCase;
function convertStringToUnderscoreCase(camelCaseString) {
    return camelCaseString
        .split(/(?=[A-Z])/)
        .join('_')
        .toLowerCase();
}
exports.convertStringToUnderscoreCase = convertStringToUnderscoreCase;
function convertAllEventsToUnderscoreCase(monorailEvent) {
    return monorailEvent.events.map(function (event) {
        var convertToUnderscoreCase = true;
        var convertMetaToUnderscoreCase = true;
        if (event &&
            event.options &&
            Object.prototype.hasOwnProperty.call(event.options, 'convertEventCase')) {
            convertToUnderscoreCase = Boolean(event.options.convertEventCase);
        }
        if (event &&
            event.options &&
            Object.prototype.hasOwnProperty.call(event.options, 'convertMetaDataCase')) {
            convertMetaToUnderscoreCase = Boolean(event.options.convertMetaDataCase);
        }
        return {
            /* eslint-disable @typescript-eslint/naming-convention */
            schema_id: event.schemaId,
            /* eslint-enable @typescript-eslint/naming-convention */
            payload: toUnderscoreCase(event.payload, convertToUnderscoreCase),
            metadata: toUnderscoreCase(event.metadata, convertMetaToUnderscoreCase),
        };
    });
}
exports.convertAllEventsToUnderscoreCase = convertAllEventsToUnderscoreCase;
